import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const search = params.get("search") || "";
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(data.categories));
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    if (search) q.set("search", search);
    api.get(`/products?${q.toString()}`).then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, [category, search]);

  const setCategory = (c) => {
    const next = new URLSearchParams(params);
    if (c) next.set("category", c); else next.delete("category");
    setParams(next);
  };

  return (
    <div data-testid="shop-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <aside className="md:col-span-3">
          <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-6">◦ The Shop</div>
          <h1 className="font-serif text-4xl lg:text-5xl tracking-tight leading-none mb-10">
            {search ? <>Searching<br /><em className="text-primary not-italic">"{search}"</em></> :
              category ? <>The<br /><em className="text-primary not-italic">{category}</em><br />room</> :
                <>All<br /><em className="text-primary not-italic">works</em>.</>}
          </h1>
          <div className="space-y-2">
            <button
              data-testid="cat-all"
              onClick={() => setCategory("")}
              className={`block text-sm py-1.5 transition-colors ${!category ? "text-primary" : "hover:text-primary"}`}
            >
              All categories
            </button>
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`cat-${c}`}
                onClick={() => setCategory(c)}
                className={`block text-sm py-1.5 transition-colors ${category === c ? "text-primary" : "hover:text-primary"}`}
              >
                {c}
              </button>
            ))}
          </div>
        </aside>
        <main className="md:col-span-9">
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="aspect-[4/5] bg-secondary animate-pulse rounded-sm" />
              ))}
            </div>
          ) : products.length === 0 ? (
            <div className="text-muted-foreground text-center py-32">No works found.</div>
          ) : (
            <>
              <div className="text-xs text-muted-foreground mb-6">{products.length} pieces</div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {products.map((p) => <ProductCard key={p.id} product={p} />)}
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
}
